<template>
  <div>
    <div class="mb-6 flex justify-end">
      <inertia-link style="color: white;" v-if="$page.props.auth.user.rol =='Admin'" class="px-8 py-4 btn-indigoOrange" :href="route('forexs.reportsIndex',forex.id)">
        <span>Reporte</span>
        <span class="hidden md:inline">Ver</span>
      </inertia-link>
       <div class="px-4">
       </div>
      <div class="px-8 py-4 btn-indigoOrange">
        <dropdown class="mt-1" placement="bottom-end">
              <div class="flex items-center cursor-pointer select-none group">
                <div style="color: #FFFFFF;" class="font-bold group-hover:text-indigo-600 focus:text-indigo-600 mr-1 whitespace-nowrap">
                  <span>Enviar Correos</span>
                </div>
                <icon class="w-5 h-5 group-hover:fill-orange-600 fill-white focus:fill-indigo-600" name="cheveron-down" />
              </div>
              <div slot="dropdown" class="mt-2 py-2 shadow-xl bg-white rounded text-sm">
                <a style="color: inexgray;" target="_blank" v-if="$page.props.auth.user.rol =='Admin'" class="block px-6 py-2 hover:bg-orange-500 hover:text-white" :href="route('forexs.generateepdf',forex.id)">
                  <span>Simple</span>
                </a>
                <a style="color: inexgray;" target="_blank" v-if="$page.props.auth.user.rol =='Admin'" class="block px-6 py-2 hover:bg-orange-500 hover:text-white" :href="route('forexs.generateepdf2',forex.id)">
                  <span>Compuesto</span>
                </a>
            </div>
            </dropdown>
      </div>
      
  </div>
    
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link style="color: #FF6D23;" class="hover:text-black-600" :href="route('forexs')">Parámetro</inertia-link>
        <span class="text-white font-medium">/  {{ forex.id }}</span>
      </h1>
     
    </div>
    <trashed-message v-if="forex.estado==0" class="mb-6" @restore="restore">
      El parámetro Fue Eliminado !
    </trashed-message>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="pr-6 pb-8 w-full lg:w-6/6">
           <label style="color: white; font-weight: 700;" class="form-label" >Pares:</label>
            <VueMultiselectComponent
              class="form-input bg-inexinput text-inexorange  border-inexgray focus:border-inexorange w-full"
              v-model="form.tipo"
              :options="options"
            />
          </div>
          <div class="pr-6 pb-8 w-full lg:w-2/6">
           <label style="color: white; font-weight: 700;" class="form-label" >Fecha:</label>
           <datepicker v-model="form.fecha" :language="es" name="uniquename" input-class="form-input bg-inexinput text-white border-inexgray focus:border-inexorange w-full"></datepicker>
          </div>
          <text-input v-model="form.dinero_ganado" :error="form.errors.dinero_ganado" class="pr-6 pb-8 w-full lg:w-2/6" label="Total $ ganado" required/>
          <text-input v-model="form.dinero_perdido" :error="form.errors.dinero_perdido" class="pr-6 pb-8 w-full lg:w-2/6" label="Total $ perdido" required/>

         
          <text-input v-model="form.total_traders" :error="form.errors.total_traders" class="pr-6 pb-8 w-full lg:w-2/6" label="Operaciones totales" required/>
          <text-input v-model="form.total_ganadas" :error="form.errors.total_ganadas" class="pr-6 pb-8 w-full lg:w-2/6" label="Operaciones ganadas" required/>
          <text-input v-model="form.total_perdidas" :error="form.errors.total_perdidas" class="pr-6 pb-8 w-full lg:w-2/6" label="Operaciones perdidas" required/>
          <text-input v-model="form.total_swap" :error="form.errors.total_swap" class="pr-6 pb-8 w-full lg:w-2/6" label="Total $ SWAP" required/>
          <text-input v-model="form.total_comision" :error="form.errors.total_comision" class="pr-6 pb-8 w-full lg:w-2/6" label="Total $ Comisión" required/>
          <text-input v-model="form.volumen" :error="form.errors.volumen" class="pr-6 pb-8 w-full lg:w-2/6" label="Total volumen" required/>


            
          <br><br>
        </div>
        <div class="px-8 py-4 bg-transparent flex items-center">
          <button v-if="forex.estado!='0' && $page.props.auth.user.rol =='Admin'" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">BORRAR</button>
          <loading-button v-if="$page.props.auth.user.rol =='Admin'" style="color: white;" :loading="form.processing" class="px-8 py-4 btn-indigoOrange ml-auto" type="submit">ACTUALIZAR</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Datepicker from 'vuejs-datepicker';
import {en, es} from 'vuejs-datepicker/dist/locale'
import VueMultiselectComponent from 'vue-multiselect-component'
import Dropdown from '@/Shared/Dropdown'

export default {
  metaInfo() {
    return {
      title: `${this.forex.id}`,
    }
  },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    Icon,
    TrashedMessage,
    Datepicker,
    Dropdown,
    VueMultiselectComponent
  },
  layout: Layout,
  props: {
    opciones: Array,
    forex: Object,
  },
  remember: 'form',
  data() {
    return {
      es: es,
      options: this.opciones,
      form: this.$inertia.form({
        _method: 'put',
        total_traders: this.forex.total_traders,
        total_ganadas: this.forex.total_ganadas,
        total_perdidas: this.forex.total_perdidas,
        total_compras: this.forex.total_compras,
        total_ventas: this.forex.total_ventas,
        total_swap: this.forex.total_swap,
        total_comision: this.forex.total_comision,
        tiempo_promedio: this.forex.tiempo_promedio,
        dinero_ganado: this.forex.dinero_ganado,
        dinero_perdido: this.forex.dinero_perdido,
        tipo: [],
        fecha: this.forex.fecha,
        volumen: this.forex.volumen,
      }),
    }
  },
  methods: {
    update() {
      var total_traders=parseInt(this.form.total_ganadas)+parseInt(this.form.total_perdidas);
      var total_operaciones = parseInt(this.form.total_compras)+parseInt(this.form.total_ventas);
      if(this.form.total_traders!=total_traders ){
        alert(total_traders);
        alert('Las operaciones no coinciden!')
      }
      else{
      this.form.post(this.route('forexs.update', this.forex.id))
      }
    },
    destroy() {
      if (confirm('Está seguro de realizar esta acción?')) {
        this.$inertia.delete(this.route('forexs.destroy', this.forex.id))
      }
    },
  },
}
</script>
